import { SREV2 } from '../../../api/pushGenie';
import { getAclViewClassName } from '../../../restrictions/utils';

const ReceiptsBt: React.FC<{
    isSelected: boolean;
    onClick: () => void;
}> = ({ onClick, isSelected }) => {
    return (
        <div
            onClick={onClick}
            className={`menuitem ${isSelected ? 'selected' : ''} ${getAclViewClassName(
                SREV2.CAN_CREATE_RECEIPT_WITH_APT,
            )}`}
        >
            <div>
                <div>
                    <svg
                        width="11"
                        height="14"
                        viewBox="0 0 11 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M11 4.5C11 4.9375 10.6562 5.25 10.25 5.25H8.65625C8.3125 7.375 6.46875 9 4.25 9H4.0625L9.15625 12.6562C9.5 12.9062 9.59375 13.375 9.34375 13.6875C9.1875 13.9062 8.96875 14 8.71875 14C8.5625 14 8.40625 13.9688 8.28125 13.875L1.28125 8.875C1.03125 8.6875 0.90625 8.34375 1.03125 8.03125C1.125 7.71875 1.40625 7.5 1.75 7.5H4.25C5.625 7.5 6.78125 6.5625 7.125 5.25H1.75C1.3125 5.25 1 4.9375 1 4.5C1 4.09375 1.3125 3.75 1.75 3.75H7.125C6.78125 2.46875 5.625 1.5 4.25 1.5H1.75C1.3125 1.5 1 1.1875 1 0.75C1 0.34375 1.3125 0 1.75 0H10.25C10.6562 0 11 0.34375 11 0.75C11 1.1875 10.6562 1.5 10.25 1.5H7.5625C8.125 2.125 8.5 2.90625 8.65625 3.75H10.25C10.6562 3.75 11 4.09375 11 4.5Z"
                            fill="#004BA8"
                        />
                    </svg>
                </div>
                <p>Receipts</p>
            </div>
            <div>
                <svg
                    width="25"
                    height="25"
                    viewBox="0 0 28 28"
                    className="fill-neutral-5 cursor-pointer"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                </svg>
            </div>
        </div>
    );
};

export default ReceiptsBt;
